
// PRODUCTS TO ADD 




// Jack Link's Protein Snack
// JackLinks-BeefJerkyVPack.jpg



// Orgain 30g Milk Protein Shake, Chocolate Fudge
// Orgain30gMilkProteinShakeChocolate.avif

// Lean Body Cookies & Cream Protein Shake 
// LeanBodyCookiesCreamProteinShake.jpeg

// Oikos 30g Protein Shake, Vanilla
// Oikos30gProteinShakeVanilla.jpeg

// Oikos 30g Chocolate Protein Shake
// Oikos30gChocolateProteinShake.webp

// Orgain 30g Milk Protein Shake, Vanilla
// Orgain30gMilkProteinShakeVanilla.webp


// { 
//     id: 'd1', name: 'Bottled Water', brand: 'Dasani', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
//     sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Purified water.',
//     urlPH: 'https://placehold.co/400x300?text=Bottled+Water', productImageFileName: 'dasaniWater.jpeg' 
//   },

// ProductPickerData_v04G_Tags.ts

// 1. Defined Taxonomies
export type ProductCategory = 'Drink' | 'Snack' | 'Candy';

export type ProductSubCategory = 
  // Drink Subtypes
  | 'Water' | 'Soda' | 'Energy' | 'Tea' | 'Coffee' | 'Juice' | 'Milk' | 'Protein'
  // Snack Subtypes
  | 'Chips' | 'Cookie' | 'Granola Bar' | 'Nuts' | 'Popcorn' | 'Crackers' | 'Pastry' | 'Mix' | 'Jerky' | 'Fruit' | 'Other'
  // Candy Subtypes
  | 'Candy Bar' | 'Gummy' | 'Hard Candy' | 'Gum' | 'Chocolate' | 'Mint';

// Updated Marketing Class to function as Tags
export type MarketingClass = 'Classic' | 'Healthy' | 'Energy' | 'Sport' | 'Zero Sugar' | 'Special';

export type IntensityLevel = 'None' | 'Low' | 'Med' | 'High';


// 2. Updated Interface
export interface IProductItem_v04G_Tags {
  id: string;
  dateAdded?: string;
  name: string;
  brand: string;
  description: string;

  // Taxonomy
  category: ProductCategory;
  subCategory: ProductSubCategory;

  // Marketing (Replaced single class with Tags array)
  tags: MarketingClass[];

  // Nutrition (Val for sorting, Level for filtering)
  sugarVal: number;       // grams
  sugarLevel: IntensityLevel;
  
  caffeineVal: number;    // mg
  caffeineLevel: IntensityLevel;

  // Media
  urlPH: string;
  productImageFileName: string;
  searchTags?: string[]
}

// 3. Normalized Data with Tags
export const SAMPLE_DATA: IProductItem_v04G_Tags[] = [
  // ==========================
  // DRINKS (d1 - d38)
  // ==========================
  
  // --- Healthier / Hydration ---


// Orgain 30g Milk Protein Shake, Chocolate Fudge
{
  id: 'JAN2026-p1',
  dateAdded: '2026-02-02T10:00:00-07:00',
  name: "30g Milk Protein Shake - Chocolate",
  brand: 'Orgain',
  category: 'Drink',
  subCategory: 'Protein',
  tags: ['Sport', 'Healthy', 'Zero Sugar'],
  searchTags: ['High Protein', 'Low Sugar', 'Ready to Drink'],
  sugarVal: 1,
  sugarLevel: 'Low',
  caffeineVal: 0,
  caffeineLevel: 'None',
  description: 'Creamy chocolate fudge flavored protein shake with 30g of milk protein.',
  urlPH: 'https://placehold.co/400x300?text=Orgain+Chocolate+Fudge',
  productImageFileName: 'Orgain30gMilkProteinShakeChocolate.avif'
},

// Lean Body Cookies & Cream Protein Shake
{
  id: 'JAN2026-p2',
  dateAdded: '2026-02-02T10:00:00-07:00',
  name: 'Cookies & Cream Protein Shake',
  brand: 'Lean Body',
  category: 'Drink',
  subCategory: 'Protein',
  tags: ['Sport', 'Healthy'],
  searchTags: ['High Protein', 'Meal Replacement', 'Low Sugar'],
  sugarVal: 2,
  sugarLevel: 'Low',
  caffeineVal: 0,
  caffeineLevel: 'None',
  description: 'Rich cookies and cream flavored protein shake designed as a meal replacement.',
  urlPH: 'https://placehold.co/400x300?text=Lean+Body+Cookies+%26+Cream',
  productImageFileName: 'LeanBodyCookiesCreamProteinShake.jpeg'
},

// Oikos 30g Protein Shake, Vanilla
{
  id: 'JAN2026-p3',
  dateAdded: '2026-02-02T10:00:00-07:00',
  name: '30g Protein Shake - Vanilla',
  brand: 'Oikos',
  category: 'Drink',
  subCategory: 'Protein',
  tags: ['Sport', 'Healthy', 'Zero Sugar'],
  searchTags: ['High Protein', 'Low Sugar', 'Vanilla'],
  sugarVal: 1,
  sugarLevel: 'Low',
  caffeineVal: 0,
  caffeineLevel: 'None',
  description: 'Smooth vanilla flavored protein shake with 30g of protein.',
  urlPH: 'https://placehold.co/400x300?text=Oikos+Vanilla+Protein',
  productImageFileName: 'Oikos30gProteinShakeVanilla.jpeg'
},

// Oikos 30g Chocolate Protein Shake
{
  id: 'JAN2026-p4',
  dateAdded: '2026-02-02T10:00:00-07:00',
  name: '30g Protein Shake',
  brand: 'Oikos',
  category: 'Drink',
  subCategory: 'Protein',
  tags: ['Sport', 'Healthy', 'Zero Sugar'],
  searchTags: ['High Protein', 'Low Sugar', 'Chocolate'],
  sugarVal: 1,
  sugarLevel: 'Low',
  caffeineVal: 0,
  caffeineLevel: 'None',
  description: 'Rich chocolate flavored protein shake delivering 30g of protein.',
  urlPH: 'https://placehold.co/400x300?text=Oikos+Chocolate+Protein',
  productImageFileName: 'Oikos30gChocolateProteinShake.webp'
},

// Orgain 30g Milk Protein Shake, Vanilla
{
  id: 'JAN2026-p5',
  dateAdded: '2026-02-02T10:00:00-07:00',
  name: '30g Milk Protein Shake - Vanilla',
  brand: 'Orgain',
  category: 'Drink',
  subCategory: 'Protein',
  tags: ['Sport', 'Healthy', 'Zero Sugar'],
  searchTags: ['High Protein', 'Low Sugar', 'Vanilla'],
  sugarVal: 1,
  sugarLevel: 'Low',
  caffeineVal: 0,
  caffeineLevel: 'None',
  description: 'Smooth vanilla flavored milk protein shake with 30g of protein.',
  urlPH: 'https://placehold.co/400x300?text=Orgain+Vanilla+Protein',
  productImageFileName: 'Orgain30gMilkProteinShakeVanilla.webp'
},
  { 
    id: 'd1', name: 'Bottled Water', brand: 'Dasani', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Purified water.',
    urlPH: 'https://placehold.co/400x300?text=Bottled+Water', productImageFileName: 'dasaniWater.jpeg' 
  },
  { 
    id: 'd2', name: 'Sparkling Water', brand: 'LaCroix', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Natural lime essence.',
    urlPH: 'https://placehold.co/400x300?text=Sparkling+Water', productImageFileName: 'laCroixSparklingWater.jpeg' 
  },
  { 
    id: 'd3', name: 'Vitaminwater Zero', brand: 'Glaceau', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Nutrient enhanced water.',
    urlPH: 'https://placehold.co/400x300?text=Vitaminwater+Zero', productImageFileName: 'VitaminWater.jpeg' 
  },
  { 
    id: 'd4', name: 'Hint Water', brand: 'Hint', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Watermelon infused water.',
    urlPH: 'https://placehold.co/400x300?text=Hint+Water', productImageFileName: 'hintWater.jpeg' 
  },

  { 
    id: 'd5u', name: 'Unsweetened Tea', brand: 'PureLeaf', category: 'Drink', subCategory: 'Tea', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 30, caffeineLevel: 'Low', description: 'Real brewed black tea.',
    urlPH: 'https://placehold.co/400x300?text=Unsweetened+Tea', productImageFileName: 'pureLeafSweetTeaZeroSugar.png' 
  },
//  pureLeafTeaNoSugar.webp 
  // pureLeafSweetTeaZeroSugar.png
  {   
    id: 'd5s', name: 'Sweet Tea', brand: 'PureLeaf', category: 'Drink', subCategory: 'Tea', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 30, caffeineLevel: 'Low', description: 'Real brewed black tea.',
    urlPH: 'https://placehold.co/400x300?text=Sweet+Tea', productImageFileName: 'pureLeafSweetTea.png' 
  },

  { 
    id: 'd6', name: 'Organic Green Tea', brand: 'Honest', category: 'Drink', subCategory: 'Tea', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 15, caffeineLevel: 'Low', description: 'Brewed organic green tea.',
    urlPH: 'https://placehold.co/400x300?text=Green+Tea', productImageFileName: 'HonestGreenTea.jpeg' 
  },
  { 
    id: 'd7', name: 'Coconut Water', brand: 'VitaCoco', category: 'Drink', subCategory: 'Water', tags: ['Healthy'], 
    sugarVal: 11, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Hydrating coconut water.',
    urlPH: 'https://placehold.co/400x300?text=Coconut+Water', productImageFileName: 'vitaCocoWater.jpeg' 
  },
  { 
    id: 'd8', name: 'Aloe Vera Drink', brand: 'Alo', category: 'Drink', subCategory: 'Juice', tags: ['Healthy'], 
    sugarVal: 15, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Real aloe pulp and juice.',
    urlPH: 'https://placehold.co/400x300?text=Aloe+Vera', productImageFileName: 'AloAloeVeraDrink.jpeg' 
  },
  { 
    id: 'd9', name: 'Kombucha', brand: 'GTs', category: 'Drink', subCategory: 'Tea', tags: ['Healthy'], 
    sugarVal: 12, sugarLevel: 'Med', caffeineVal: 10, caffeineLevel: 'Low', description: 'Fermented probiotic tea.',
    urlPH: 'https://placehold.co/400x300?text=Kombucha', productImageFileName: 'KombuchaDrink.jpeg' 
  },
  { 
    id: 'd10', name: 'Almond Milk', brand: 'Silk', category: 'Drink', subCategory: 'Milk', tags: ['Healthy'], 
    sugarVal: 5, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Vanilla almond beverage.',
    urlPH: 'https://placehold.co/400x300?text=Almond+Milk', productImageFileName: 'AlmondMilk.webp' 
  },
  { 
    id: 'd11', name: 'Green Juice', brand: 'Naked', category: 'Drink', subCategory: 'Juice', tags: ['Healthy'], 
    sugarVal: 25, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Kale, spinach and fruit blend.',
    urlPH: 'https://placehold.co/400x300?text=Green+Juice', productImageFileName: 'NakedGreenJuice.jpeg' 
  },

  // --- Kids Favorites ---
  { 
    id: 'd12', name: 'Capri Sun', brand: 'Kraft', category: 'Drink', subCategory: 'Juice', tags: ['Classic'], 
    sugarVal: 16, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Fruit punch juice pouch.',
    urlPH: 'https://placehold.co/400x300?text=Capri+Sun', productImageFileName: 'CapriSunDrink.avif' 
  },
  { 
    id: 'd13', name: 'Juice Box', brand: 'Honest Kids', category: 'Drink', subCategory: 'Juice', tags: ['Healthy'], 
    sugarVal: 9, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Organic apple juice.',
    urlPH: 'https://placehold.co/400x300?text=Juice+Box', productImageFileName: 'HonestJuiceBox.jpeg' 
  },
  { 
    id: 'd14', name: 'Chocolate Milk', brand: 'Horizon', category: 'Drink', subCategory: 'Milk', tags: ['Classic'], 
    sugarVal: 22, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Organic low-fat chocolate milk.',
    urlPH: 'https://placehold.co/400x300?text=Chocolate+Milk', productImageFileName: 'HorizonChocolateMilk.jpeg' 
  },
  { 
    id: 'd15', name: 'Strawberry Milk', brand: 'Nesquik', category: 'Drink', subCategory: 'Milk', tags: ['Classic'], 
    sugarVal: 22, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Sweet strawberry milk.',
    urlPH: 'https://placehold.co/400x300?text=Strawberry+Milk', productImageFileName: 'NesquickStrawberryMilk.png' 
  },
  { 
    id: 'd16', name: 'Gatorade Mini', brand: 'Gatorade', category: 'Drink', subCategory: 'Energy', tags: ['Sport'], 
    sugarVal: 12, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Kid-sized sports drink.',
    urlPH: 'https://placehold.co/400x300?text=Gatorade+Mini', productImageFileName: 'GatoradeMini.jpeg' 
  },
  { 
    id: 'd17', name: 'Orange Soda', brand: 'Fanta', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 44, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Orange fruit soda.',
    urlPH: 'https://placehold.co/400x300?text=Orange+Soda', productImageFileName: 'FantaOrangeSoda.jpeg' 
  },
  { 
    id: 'd18', name: 'Fruit Punch', brand: 'Minute Maid', category: 'Drink', subCategory: 'Juice', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Mixed fruit juice drink.',
    urlPH: 'https://placehold.co/400x300?text=Fruit+Punch', productImageFileName: 'MinuteMaidFruitPunch.jpeg' 
  },
  { 
    id: 'd19', name: 'Lemonade', brand: 'Simply', category: 'Drink', subCategory: 'Juice', tags: ['Classic'], 
    sugarVal: 28, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'All natural lemonade.',
    urlPH: 'https://placehold.co/400x300?text=Lemonade', productImageFileName: 'SimplyLemonade.jpeg' 
  },

  // --- Office / Soda ---
  { 
    id: 'd21', name: 'Cola Classic', brand: 'Coke', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 39, sugarLevel: 'High', caffeineVal: 34, caffeineLevel: 'Med', description: 'The original cola.',
    urlPH: 'https://placehold.co/400x300?text=Cola+Classic', productImageFileName: 'CokeColaClassic.jpeg' 
  },
  { 
    id: 'd22', name: 'Diet Soda', brand: 'Diet Coke', category: 'Drink', subCategory: 'Soda', tags: ['Classic', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 46, caffeineLevel: 'Med', description: 'Zero calorie cola.',
    urlPH: 'https://placehold.co/400x300?text=Diet+Soda', productImageFileName: 'DietCokeSoda.jpeg' 
  },
  { 
    id: 'd23', name: 'Root Beer', brand: 'A&W', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 43, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Aged vanilla root beer.',
    urlPH: 'https://placehold.co/400x300?text=Root+Beer', productImageFileName: 'AandWRootBeer.jpeg' 
  },
  { 
    id: 'd24', name: 'Ginger Ale', brand: 'Canada Dry', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 33, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Real ginger ale.',
    urlPH: 'https://placehold.co/400x300?text=Ginger+Ale', productImageFileName: 'CanadaDryGingerAle.jpeg' 
  },
  { 
    id: 'd25', name: 'Club Soda', brand: 'Schweppes', category: 'Drink', subCategory: 'Soda', tags: ['Classic', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Carbonated water.',
    urlPH: 'https://placehold.co/400x300?text=Club+Soda', productImageFileName: 'ScheweppesClubSoda.jpeg' 
  },

  // --- Energy / Warehouse / Industrial ---
  { 
    id: 'd26', name: 'Monster Energy', brand: 'Monster', category: 'Drink', subCategory: 'Energy', tags: ['Energy'], 
    sugarVal: 54, sugarLevel: 'High', caffeineVal: 160, caffeineLevel: 'High', description: 'Original energy blend.',
    urlPH: 'https://placehold.co/400x300?text=Monster+Energy', productImageFileName: 'MonsterEnergy.jpeg' 
  },


  { 
    id: 'd27a', name: 'Red Bull', brand: 'Red Bull', category: 'Drink', subCategory: 'Energy', tags: ['Energy'], 
    sugarVal: 27, sugarLevel: 'High', caffeineVal: 80, caffeineLevel: 'High', description: 'Vitalizes body and mind.',
    urlPH: 'https://placehold.co/400x300?text=Red+Bull', productImageFileName: 'RedBullEnergyDrink.jpeg' 
  },
  { 
    id: 'd27b', name: 'Red Bull - Sugar Free', brand: 'Red Bull', category: 'Drink', subCategory: 'Energy', tags: ['Energy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 80, caffeineLevel: 'High', description: 'Vitalizes body and mind.',
    urlPH: 'https://placehold.co/400x300?text=Red+Bull', productImageFileName: 'RedBullEnergyDrinkSugarFree.jpeg' 
  },
  { 
    id: 'd27c', name: 'Red Bull RED', brand: 'Red Bull', category: 'Drink', subCategory: 'Energy', tags: ['Energy'], 
    sugarVal: 27, sugarLevel: 'High', caffeineVal: 80, caffeineLevel: 'High', description: 'Vitalizes body and mind.',
    urlPH: 'https://placehold.co/400x300?text=Red+Bull', productImageFileName: 'RedBullRedBullEnergyDrink.jpeg' 
  },

  //NA
  // { 
  //   id: 'd29', name: 'Cold Brew', brand: 'Starbucks', category: 'Drink', subCategory: 'Coffee', tags: ['Energy', 'Zero Sugar'], 
  //   sugarVal: 0, sugarLevel: 'None', caffeineVal: 180, caffeineLevel: 'High', description: 'Unsweetened black coffee.',
  //   urlPH: 'https://placehold.co/400x300?text=Cold+Brew', productImageFileName: 'StarbucksColdBrew.jpeg' 
  // },

{ 
  id: 's32coffee',
  name: 'Premium Espresso Beverage, Espresso and Cream',
  brand: 'Starbucks',
  category: 'Drink',
  subCategory: 'Coffee',
  tags: ['Energy'],

  sugarVal: 14,
  sugarLevel: 'Med',
  caffeineVal: 120,
  caffeineLevel: 'High',

  description: 'Rich espresso blended with cream for a smooth, bold coffee drink.',
  urlPH: 'https://placehold.co/400x300?text=Starbucks+Espresso',
  productImageFileName: 'StarbucksPremiumEspressoBeverage.jpeg'
},

{ 
  id: 's33coffee',
  name: 'Java Energy Drink, Loca Moca',
  brand: 'Monster',
  category: 'Drink',
  subCategory: 'Coffee',
  tags: ['Energy'],

  sugarVal: 31,
  sugarLevel: 'High',
  caffeineVal: 200,
  caffeineLevel: 'High',

  description: 'Coffee and cream flavored energy drink with a strong caffeine kick.',
  urlPH: 'https://placehold.co/400x300?text=Monster+Loca+Moca',
  productImageFileName: 'MonsterJavaEnergyDrinkLocaMoca.webp'
},

{ 
  id: 's34coffee',
  name: 'Java Energy Drink, Mean Bean',
  brand: 'Monster',
  category: 'Drink',
  subCategory: 'Coffee',
  tags: ['Energy'],

  sugarVal: 31,
  sugarLevel: 'High',
  caffeineVal: 200,
  caffeineLevel: 'High',

  description: 'Smooth vanilla bean coffee energy drink with bold flavor and energy.',
  urlPH: 'https://placehold.co/400x300?text=Monster+Mean+Bean',
  productImageFileName: 'MonsterJavaEnergyDrinkMeanBean.webp'
},





  { 
    id: 'd30', name: 'Sweet Tea', brand: 'Gold Peak', category: 'Drink', subCategory: 'Tea', tags: ['Classic'], 
    sugarVal: 40, sugarLevel: 'High', caffeineVal: 45, caffeineLevel: 'Med', description: 'Southern style sweet tea.',
    urlPH: 'https://placehold.co/400x300?text=Sweet+Tea', productImageFileName: 'GoldPeakSweetTea.jpeg' 
  },
  { 
    id: 'd31', name: 'Powerade', brand: 'Powerade', category: 'Drink', subCategory: 'Energy', tags: ['Sport'], 
    sugarVal: 34, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Mountain berry blast.',
    urlPH: 'https://placehold.co/400x300?text=Powerade', productImageFileName: 'PowerAidDrink.jpeg' 
  },

  // --- Fitness / Gym ---
  { 
    id: 'd32', name: 'Gatorade Zero', brand: 'Gatorade', category: 'Drink', subCategory: 'Energy', tags: ['Sport', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Electrolytes zero sugar.',
    urlPH: 'https://placehold.co/400x300?text=Gatorade+Zero', productImageFileName: 'gatoradeZero.webp' 
  },
  { 
    id: 'd33', name: 'Protein Shake', brand: 'Muscle Milk', category: 'Drink', subCategory: 'Protein', tags: ['Sport', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: '25g protein chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Protein+Shake', productImageFileName: 'MuscleMilkDrink.jpeg' 
  },
  { 
    id: 'd34', name: 'BCAA Drink', brand: 'Celsius', category: 'Drink', subCategory: 'Energy', tags: ['Energy', 'Sport', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 200, caffeineLevel: 'High', description: 'Essential energy fitness drink.',
    urlPH: 'https://placehold.co/400x300?text=BCAA+Drink', productImageFileName: 'CelsiusDrink.jpeg' 
  },
  { 
    id: 'd35', name: 'Electrolyte Water', brand: 'SmartWater', category: 'Drink', subCategory: 'Water', tags: ['Sport', 'Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Vapor distilled water.',
    urlPH: 'https://placehold.co/400x300?text=Electrolyte+Water', productImageFileName: 'smartWater.jpeg' 
  },
  { 
    id: 'd36', name: 'Aloe Water', brand: 'Detox', category: 'Drink', subCategory: 'Water', tags: ['Healthy'], 
    sugarVal: 8, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Infused aloe water.',
    urlPH: 'https://placehold.co/400x300?text=Aloe+Water', productImageFileName: 'DetoxAloeWater.jpeg' 
  },
  { 
    id: 'd37', name: 'Powerade Zero', brand: 'Powerade', category: 'Drink', subCategory: 'Energy', tags: ['Sport', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Zero mixed berry.',
    urlPH: 'https://placehold.co/400x300?text=Powerade+Zero', productImageFileName: 'PowerAidZeroDrink.jpeg' 
  },
  { 
    id: 'd38', name: 'Canned Coffee', brand: 'LaColombe', category: 'Drink', subCategory: 'Coffee', tags: ['Energy'], 
    sugarVal: 15, sugarLevel: 'Med', caffeineVal: 120, caffeineLevel: 'High', description: 'Double shot latte.',
    urlPH: 'https://placehold.co/400x300?text=Canned+Coffee', productImageFileName: 'LaColombeCannedCoffee.jpeg' 
  },


  // ==========================
  // NEW DRINKS (d39 - d48)
  // ==========================
  { 
    id: 'd39', name: 'Dr Pepper', brand: 'Keurig Dr Pepper', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 40, sugarLevel: 'High', caffeineVal: 41, caffeineLevel: 'Med', description: 'Unique blend of 23 flavors.',
    urlPH: 'https://placehold.co/400x300?text=Dr+Pepper', productImageFileName: 'DrPepper.jpeg' 
  },
  { 
    id: 'd40', name: 'Sprite', brand: 'Coke', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 38, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Lemon-lime soda.',
    urlPH: 'https://placehold.co/400x300?text=Sprite', productImageFileName: 'SpriteSoda.jpeg' 
  },
  { 
    id: 'd41', name: 'Mountain Dew', brand: 'PepsiCo', category: 'Drink', subCategory: 'Soda', tags: ['Classic', 'Energy'], 
    sugarVal: 46, sugarLevel: 'High', caffeineVal: 54, caffeineLevel: 'Med', description: 'Citrus flavored soda.',
    urlPH: 'https://placehold.co/400x300?text=Mountain+Dew', productImageFileName: 'MountainDew.jpeg' 
  },
  { 
    id: 'd42', name: 'Pepsi', brand: 'PepsiCo', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 41, sugarLevel: 'High', caffeineVal: 38, caffeineLevel: 'Med', description: 'Original cola taste.',
    urlPH: 'https://placehold.co/400x300?text=Pepsi', productImageFileName: 'pepsican.webp' 
  },
  { 
    id: 'd43', name: 'Arizona Green Tea', brand: 'Arizona', category: 'Drink', subCategory: 'Tea', tags: ['Classic'], 
    sugarVal: 17, sugarLevel: 'Med', caffeineVal: 15, caffeineLevel: 'Low', description: 'Green tea with ginseng and honey.',
    urlPH: 'https://placehold.co/400x300?text=Arizona+Tea', productImageFileName: 'ArizonaGreenTea.jpeg' 
  },
  { 
    id: 'd44', name: 'Frappuccino', brand: 'Starbucks', category: 'Drink', subCategory: 'Coffee', tags: ['Energy'], 
    sugarVal: 32, sugarLevel: 'High', caffeineVal: 110, caffeineLevel: 'High', description: 'Chilled coffee drink vanilla.',
    urlPH: 'https://placehold.co/400x300?text=Frappuccino', productImageFileName: 'StarbucksFrappuccino.jpeg' 
  },
  { 
    id: 'd45', name: 'Bai Antioxidant', brand: 'Bai', category: 'Drink', subCategory: 'Juice', tags: ['Healthy'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 35, caffeineLevel: 'Low', description: 'Brasilia blueberry infusion.',
    urlPH: 'https://placehold.co/400x300?text=Bai+Drink', productImageFileName: 'BaiBaiAntioxidantDrink.jpeg' 
  },
  { 
    id: 'd46', name: 'Yoo-hoo', brand: 'Keurig Dr Pepper', category: 'Drink', subCategory: 'Milk', tags: ['Classic'], 
    sugarVal: 16, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Chocolate drink.',
    urlPH: 'https://placehold.co/400x300?text=Yoo-hoo', productImageFileName: 'Yoo-HooDrink.jpeg' 
  },
  { 
    id: 'd47', name: '7Up', brand: 'Keurig Dr Pepper', category: 'Drink', subCategory: 'Soda', tags: ['Classic'], 
    sugarVal: 38, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Lemon lime soda.',
    urlPH: 'https://placehold.co/400x300?text=7Up', productImageFileName: '7UpDrink.jpeg' 
  },
  { 
    id: 'd48', name: 'BodyArmor', brand: 'Coca-Cola', category: 'Drink', subCategory: 'Energy', tags: ['Sport'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Super drink strawberry banana.',
    urlPH: 'https://placehold.co/400x300?text=BodyArmor', productImageFileName: 'BodyArmorDrink.jpeg' 
  },
  { 
    id: 'd100', name: 'C4 Energy Drink', brand: 'C4', category: 'Drink', subCategory: 'Energy', tags: ['Energy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 200, caffeineLevel: 'High', description: 'Performance energy drink with zero sugar and beta-alanine.',
    urlPH: 'https://placehold.co/400x300?text=C4+Energy', productImageFileName: 'C4EnergyDrink.jpg' 
  },
  { 
    id: 'd101', name: 'ZOA Energy Drink', brand: 'ZOA', category: 'Drink', subCategory: 'Energy', tags: ['Energy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 160, caffeineLevel: 'High', description: 'Clean energy with electrolytes, B-vitamins, and Vitamin C.',
    urlPH: 'https://placehold.co/400x300?text=ZOA+Energy', productImageFileName: 'ZOAEnergyDrink.webp' 
  },
  { 
    id: 'd102', name: 'Waterloo Sparkling Water', brand: 'Waterloo', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Purified sparkling water with natural fruit flavors.',
    urlPH: 'https://placehold.co/400x300?text=Waterloo', productImageFileName: 'WaterLoo.jpg' 
  },
  { 
    id: 'd103', name: 'FIJI Natural Artesian Water', brand: 'FIJI', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Earth’s finest water bottled at the source in Viti Levu.',
    urlPH: 'https://placehold.co/400x300?text=FIJI+Water', productImageFileName: 'fijiWater.jpg' 
  },
  { 
    id: 'd104', name: 'San Pellegrino Essenza', brand: 'San Pellegrino', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Flavored sparkling mineral water with Mediterranean fruit blends.',
    urlPH: 'https://placehold.co/400x300?text=S.Pellegrino+Essenza', productImageFileName: 'SanPellegrinoEssenza.avif' 
  },
  { 
    id: 'd105', name: 'San Pellegrino Sparkling Natural Mineral Water', brand: 'San Pellegrino', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Unflavored natural mineral water with fine carbonation.',
    urlPH: 'https://placehold.co/400x300?text=S.Pellegrino+Natural', productImageFileName: 'SanPellegrinoSparklingNaturalWater.avif' 
  },
  { 
    id: 'd106', name: 'Maison Perrier Sparkling Water', brand: 'Perrier', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Elegant French sparkling water with a crisp taste.',
    urlPH: 'https://placehold.co/400x300?text=Maison+Perrier', productImageFileName: 'MaisonPerrierSparklingWater.jpg' 
  },
  { 
    id: 'd107', name: 'Topo Chico Carbonated Mineral Water', brand: 'Topo Chico', category: 'Drink', subCategory: 'Water', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Legendary sparkling mineral water with a high carbonation level.',
    urlPH: 'https://placehold.co/400x300?text=Topo+Chico', productImageFileName: 'topoChico.webp' 
  },
  { 
    id: 'd108', name: 'Propel Electrolyte Water Beverage', brand: 'Propel', category: 'Drink', subCategory: 'Water', tags: ['Sport', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Zero calorie fitness water enhanced with electrolytes and B vitamins.',
    urlPH: 'https://placehold.co/400x300?text=Propel+Water', productImageFileName: 'propelWater.webp' 
  },



  // ==========================
  // SNACKS (s1 - s38)
  // ==========================

  // --- Healthier ---
  { 
    id: 's1', name: 'Kind Bar', brand: 'KIND', category: 'Snack', subCategory: 'Granola Bar', tags: ['Healthy'], 
    sugarVal: 5, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Dark chocolate nuts & sea salt.',
    urlPH: 'https://placehold.co/400x300?text=Kind+Bar', productImageFileName: 'kindbars.jpeg' 
  },
  { 
    id: 's2', name: 'Larabar', brand: 'Larabar', category: 'Snack', subCategory: 'Granola Bar', tags: ['Healthy'], 
    sugarVal: 18, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Peanut butter cookie.',
    urlPH: 'https://placehold.co/400x300?text=Larabar', productImageFileName: 'lauraBar.webp' 
  },
  { 
    id: 's3', name: 'Seaweed Snacks', brand: 'GimMe', category: 'Snack', subCategory: 'Other', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Roasted seaweed sheets.',
    urlPH: 'https://placehold.co/400x300?text=Seaweed+Snacks', productImageFileName: 'gimmeSeaweedSnack.jpeg' 
  },
  { 
    id: 's4', name: 'Almonds', brand: 'Blue Diamond', category: 'Snack', subCategory: 'Nuts', tags: ['Healthy'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Lightly salted almonds.',
    urlPH: 'https://placehold.co/400x300?text=Almonds', productImageFileName: 'blueDiamondAlmonds.jpeg' 
  },
  { 
    id: 's5', name: 'Baked Chips', brand: 'SunChips', category: 'Snack', subCategory: 'Chips', tags: ['Healthy'], 
    sugarVal: 3, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Harvest cheddar baked snacks.',
    urlPH: 'https://placehold.co/400x300?text=Baked+Chips', productImageFileName: 'sunchipsSnack.jpeg' 
  },
  { 
    id: 's6', name: 'Skinny Pop', brand: 'SkinnyPop', category: 'Snack', subCategory: 'Popcorn', tags: ['Healthy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Air popped popcorn.',
    urlPH: 'https://placehold.co/400x300?text=Skinny+Pop', productImageFileName: 'skinnyPopSnack.jpeg' 
  },
  { 
    id: 's7', name: 'Dried Mango', brand: 'Peeled', category: 'Snack', subCategory: 'Fruit', tags: ['Healthy'], 
    sugarVal: 28, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Gently dried fruit.',
    urlPH: 'https://placehold.co/400x300?text=Dried+Mango', productImageFileName: 'peeledDriedMango.jpeg' 
  },
  { 
    id: 's9', name: 'Apple Chips', brand: 'Bare', category: 'Snack', subCategory: 'Fruit', tags: ['Healthy'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Baked crunchy apple chips.',
    urlPH: 'https://placehold.co/400x300?text=Apple+Chips', productImageFileName: 'bareAppleChipsRedSnack.jpeg' 
  },
  { 
    id: 's10', name: 'Pistachios', brand: 'Wonderful', category: 'Snack', subCategory: 'Nuts', tags: ['Healthy'], 
    sugarVal: 2, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Roasted and salted.',
    urlPH: 'https://placehold.co/400x300?text=Pistachios', productImageFileName: 'pistachiosSnack.jpeg' 
  },

  // --- Kids Favorites ---
  { 
    id: 's11', name: 'Fruit Snacks', brand: 'Welch\'s', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 11, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Mixed fruit gummies.',
    urlPH: 'https://placehold.co/400x300?text=Fruit+Snacks', productImageFileName: 'welchsFruitSnack.jpeg' 
  },
  { 
    id: 's12', name: 'Goldfish', brand: 'Pepperidge', category: 'Snack', subCategory: 'Crackers', tags: ['Classic', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Baked cheddar crackers.',
    urlPH: 'https://placehold.co/400x300?text=Goldfish', productImageFileName: 'goldfishSnack.jpeg' 
  },
  { 
    id: 's13', name: 'Oreo Pack', brand: 'Nabisco', category: 'Snack', subCategory: 'Cookie', tags: ['Classic'], 
    sugarVal: 14, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Chocolate sandwich cookies.',
    urlPH: 'https://placehold.co/400x300?text=Oreo+Pack', productImageFileName: 'oreoCookieSnack.jpeg' 
  },
  { 
    id: 's14', name: 'Chex Mix', brand: 'General Mills', category: 'Snack', subCategory: 'Mix', tags: ['Classic'], 
    sugarVal: 3, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Savory snack mix.',
    urlPH: 'https://placehold.co/400x300?text=Chex+Mix', productImageFileName: 'chexMixSnack.jpeg' 
  },
  
  // { 
  //   id: 's15', name: 'M&Ms', brand: 'Mars', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
  //   sugarVal: 25, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Milk chocolate candy.',
  //   urlPH: 'https://placehold.co/400x300?text=M&Ms', productImageFileName: 'MandMs.jpg' 
  // },

  { 
    id: 's17', name: 'Teddy Grahams', brand: 'Nabisco', category: 'Snack', subCategory: 'Crackers', tags: ['Classic'], 
    sugarVal: 8, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Honey graham snacks.',
    urlPH: 'https://placehold.co/400x300?text=Teddy+Grahams', productImageFileName: 'TeddyGrahamsSnack.jpeg' 
  },
  { 
    id: 's18', name: 'Rice Krispies', brand: 'Kellogg\'s', category: 'Snack', subCategory: 'Granola Bar', tags: ['Classic'], 
    sugarVal: 12, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Marshmallow snack bar.',
    urlPH: 'https://placehold.co/400x300?text=Rice+Krispies', productImageFileName: 'RiceKrispTreatsSnack.jpeg' 
  },
  { 
    id: 's19', name: 'Cheese Crackers', brand: 'Cheez-It', category: 'Snack', subCategory: 'Crackers', tags: ['Classic', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Baked snack crackers.',
    urlPH: 'https://placehold.co/400x300?text=Cheese+Crackers', productImageFileName: 'cheezItSnack.jpeg' 
  },

  // --- Office / General ---
  { 
    id: 's20', name: 'Granola Bar', brand: 'Nature Valley', category: 'Snack', subCategory: 'Granola Bar', tags: ['Classic'], 
    sugarVal: 11, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Oats \'n Honey crunch.',
    urlPH: 'https://placehold.co/400x300?text=Granola+Bar', productImageFileName: 'natureValleyBar.jpeg' 
  },
  { 
    id: 's21', name: 'Trail Mix', brand: 'Kirkland', category: 'Snack', subCategory: 'Mix', tags: ['Energy'], 
    sugarVal: 15, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Nuts, raisins and M&Ms.',
    urlPH: 'https://placehold.co/400x300?text=Trail+Mix', productImageFileName: 'kirklandTrailMixSnack.jpeg' 
  },
  { 
    id: 's22', name: 'Pretzels', brand: 'Snyder\'s', category: 'Snack', subCategory: 'Crackers', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Mini pretzels.',
    urlPH: 'https://placehold.co/400x300?text=Pretzels', productImageFileName: 'snydersSnack.jpeg' 
  },
  { 
    id: 's25', name: 'Mixed Nuts', brand: 'Planters', category: 'Snack', subCategory: 'Nuts', tags: ['Healthy'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Salted nut mix.',
    urlPH: 'https://placehold.co/400x300?text=Mixed+Nuts', productImageFileName: 'plantersMixedNuts.jpeg' 
  },

  // --- Warehouse / Industrial (Hearty) ---
  { 
    id: 's26', name: 'Beef Jerky', brand: 'Jack Links', category: 'Snack', subCategory: 'Jerky', tags: ['Energy'], 
    sugarVal: 5, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Original smoked beef.',
    urlPH: 'https://placehold.co/400x300?text=Beef+Jerky', productImageFileName: 'JackLinks-BeefJerky.png' 
  },
  { 
    id: 's27', name: 'Doritos', brand: 'Frito-Lay', category: 'Snack', subCategory: 'Chips', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Nacho cheese tortilla chips.',
    urlPH: 'https://placehold.co/400x300?text=Doritos', productImageFileName: 'doritosSnackRed.jpeg' 
  },
  // { 
  //   id: 's28', name: 'Pop-Tarts', brand: 'Kellogg\'s', category: 'Snack', subCategory: 'Pastry', tags: ['Classic'], 
  //   sugarVal: 30, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Frosted strawberry pastry.',
  //   urlPH: 'https://placehold.co/400x300?text=Pop-Tarts', productImageFileName: 'ccPoptarts-strawberry.webp' 
  // },
  { 
    id: 's29', name: 'Potato Chips', brand: 'Lays', category: 'Snack', subCategory: 'Chips', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Classic salted chips.',
    urlPH: 'https://placehold.co/400x300?text=Potato+Chips', productImageFileName: 'laysChipsSnack.jpeg' 
  },
  { 
    id: 's30', name: 'Muffin', brand: 'Otis Spunkmeyer', category: 'Snack', subCategory: 'Pastry', tags: ['Classic'], 
    sugarVal: 28, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Blueberry muffin.',
    urlPH: 'https://placehold.co/400x300?text=Muffin', productImageFileName: 'otisSpunkmeyerMuffinSnack.png' 
  },
  { 
    id: 's31', name: 'Cheetos', brand: 'Frito-Lay', category: 'Snack', subCategory: 'Chips', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Crunchy cheese snacks.',
    urlPH: 'https://placehold.co/400x300?text=Cheetos', productImageFileName: 'cheetos.webp' 
  },

  // --- Fitness / Gym ---
  // { 
  //   id: 's33', name: 'Quest Bar', brand: 'Quest', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
  //   sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Cookies and cream protein.',
  //   urlPH: 'https://placehold.co/400x300?text=Quest+Bar', productImageFileName: 'ccquestbar.webp' 
  // },
  { 
    id: 's35', name: 'Tuna Pack', brand: 'Starkist', category: 'Snack', subCategory: 'Other', tags: ['Energy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Lemon pepper tuna.',
    urlPH: 'https://placehold.co/400x300?text=Tuna+Pack', productImageFileName: 'starkistTunaPack.jpeg' 
  },
  { 
    id: 's36', name: 'Protein Cookie', brand: 'Lenny & Larry', category: 'Snack', subCategory: 'Cookie', tags: ['Energy'], 
    sugarVal: 12, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Plant-based protein cookie.',
    urlPH: 'https://placehold.co/400x300?text=Protein+Cookie', productImageFileName: 'lennyLarryProteinCookieSnack.jpeg' 
  },
  { 
    id: 's37', name: 'Edamame', brand: 'Seapoint', category: 'Snack', subCategory: 'Other', tags: ['Healthy'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Dry roasted edamame.',
    urlPH: 'https://placehold.co/400x300?text=Edamame', productImageFileName: 'edamameSingleSnack.jpeg' 
  },
  { 
    id: 's38', name: 'Veggie Chips', brand: 'Terra', category: 'Snack', subCategory: 'Chips', tags: ['Healthy'], 
    sugarVal: 3, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Real vegetable chips.',
    urlPH: 'https://placehold.co/400x300?text=Veggie+Chips', productImageFileName: 'terraVeggieChipsSnack.jpeg' 
  },

  // ==========================
  // CANDY / CHOCOLATE (s39 - s58)
  // ==========================

  { 
    id: 's39', name: 'Snickers', brand: 'Mars', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 27, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Nougat topped with caramel and peanuts.',
    urlPH: 'https://placehold.co/400x300?text=Snickers', productImageFileName: 'SnickersCandyBar.jpeg' 
  },
  { 
    id: 's40', name: 'Reese\'s Cups', brand: 'Hershey', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 22, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Peanut butter cups covered in chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Reeses+Cups', productImageFileName: 'ReesesCandyBar.jpeg' 
  },
  { 
    id: 's41', name: 'Kit Kat', brand: 'Hershey', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 6, caffeineLevel: 'Low', description: 'Crisp wafers in milk chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Kit+Kat', productImageFileName: 'kitKat.jpeg' 
  },
  { 
    id: 's42', name: 'M&Ms Peanut', brand: 'Mars', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 25, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Peanut milk chocolate candy.',
    urlPH: 'https://placehold.co/400x300?text=Peanut+M%26Ms', productImageFileName: 'MandMPeanut.jpeg' 
  },
  { 
    id: 's43', name: 'Twix', brand: 'Mars', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Cookie bars with caramel and chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Twix', productImageFileName: 'Twix.jpeg' 
  },


    

  { 
    id: 's44', name: 'Hershey\'s Bar', brand: 'Hershey', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 10, caffeineLevel: 'Low', description: 'Classic milk chocolate bar.',
    urlPH: 'https://placehold.co/400x300?text=Hersheys+Bar', productImageFileName: 'HersheysChocolateBar.jpeg' 
  },

{ 
    id: 's44a',
    name: "Hershey's Almond Bar",
    brand: 'Hershey',
    category: 'Candy',
    subCategory: 'Chocolate',
    tags: ['Classic'],

    sugarVal: 25,
    sugarLevel: 'Med',

    caffeineVal: 10,
    caffeineLevel: 'Low',

    description: 'Classic milk chocolate bar with crunchy almonds.',
    urlPH: 'https://placehold.co/400x300?text=Hersheys+Almond+Bar',
    productImageFileName: 'HersheysCandyBarAlmonds.jpeg'
  },

  { 
    id: 's45', name: 'Milky Way', brand: 'Mars', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 31, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Chocolate malt-flavored nougat and caramel.',
    urlPH: 'https://placehold.co/400x300?text=Milky+Way', productImageFileName: 'MilkyWayBar.jpeg' 
  },
  { 
    id: 's46', name: 'Butterfinger', brand: 'Ferrero', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Crispety, crunchety, peanut-buttery.',
    urlPH: 'https://placehold.co/400x300?text=Butterfinger', productImageFileName: 'ButterFingerCandyBar.jpeg' 
  },
  { 
    id: 's47', name: 'Crunch Bar', brand: 'Ferrero', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Creamy milk chocolate with crisped rice.',
    urlPH: 'https://placehold.co/400x300?text=Crunch+Bar', productImageFileName: 'CrunchCandyBar.jpeg' 
  },
  { 
    id: 's48', name: '3 Musketeers', brand: 'Mars', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 36, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Whipped chocolate nougat.',
    urlPH: 'https://placehold.co/400x300?text=3+Musketeers', productImageFileName: '3MusketeersCandyBar.jpeg' 
  },
  { 
    id: 's49', name: 'Almond Joy', brand: 'Hershey', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 20, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Coconut and almond in milk chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Almond+Joy', productImageFileName: 'AlmondJoyCandyBar.jpeg' 
  },
  { 
    id: 's50', name: 'PayDay', brand: 'Hershey', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Salted peanuts and caramel.',
    urlPH: 'https://placehold.co/400x300?text=PayDay', productImageFileName: 'PayDayCandyBar.jpeg' 
  },
  { 
    id: 's51', name: '100 Grand', brand: 'Ferrero', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 22, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Chewy caramel, milk chocolate, crispy rice.',
    urlPH: 'https://placehold.co/400x300?text=100+Grand', productImageFileName: '100GrandCandyBar.jpeg' 
  },
  { 
    id: 's52', name: 'Skittles', brand: 'Mars', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 42, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Bite-sized fruit flavored candies.',
    urlPH: 'https://placehold.co/400x300?text=Skittles', productImageFileName: 'SkittlesCandyBar.jpeg' 
  },
  { 
    id: 's53', name: 'Starburst', brand: 'Mars', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 22, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Chewy fruit square candies.',
    urlPH: 'https://placehold.co/400x300?text=Starburst', productImageFileName: 'StarburstCandy.jpeg' 
  },
  { 
    id: 's54', name: 'Twizzlers', brand: 'Hershey', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 19, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Strawberry flavored licorice twists.',
    urlPH: 'https://placehold.co/400x300?text=Twizzlers', productImageFileName: 'twizzlersCandy.jpeg' 
  },
  { 
    id: 's55', name: 'Swedish Fish', brand: 'Mondelez', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 23, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Soft and chewy red fish gummy.',
    urlPH: 'https://placehold.co/400x300?text=Swedish+Fish', productImageFileName: 'SwedishFishCandy.jpeg' 
  },
  { 
    id: 's57', name: 'Junior Mints', brand: 'Tootsie Roll', category: 'Candy', subCategory: 'Mint', tags: ['Classic'], 
    sugarVal: 32, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Creamy mints in pure chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Junior+Mints', productImageFileName: 'JuniorMintsCandy.jpeg' 
  },
  { 
    id: 's58', name: 'York Peppermint Patty', brand: 'Hershey', category: 'Candy', subCategory: 'Mint', tags: ['Classic'], 
    sugarVal: 25, sugarLevel: 'High', caffeineVal: 10, caffeineLevel: 'Low', description: 'Dark chocolate covered peppermint.',
    urlPH: 'https://placehold.co/400x300?text=York+Patty', productImageFileName: 'YORKPeppermintPatty.jpeg' 
  },



  // ==========================
  // NEW SNACKS (s59 - s68)
  // ==========================
  { 
    id: 'flcm01', name: 'Frito-Lay Classic Mix', brand: 'Frito-Lay', category: 'Snack', subCategory: 'Mix', tags: ['Classic', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Original Chips.',
    urlPH: 'https://placehold.co/400x300?text=Frito-Lay+Classic+Mix', productImageFileName: 'Frito-LayClassicMix.jpg' 
  },
    
  { 
    id: 's59', name: 'Pringles', brand: 'Kellogg\'s', category: 'Snack', subCategory: 'Chips', tags: ['Classic', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'Original potato crisps.',
    urlPH: 'https://placehold.co/400x300?text=Pringles', productImageFileName: 'pringles.avif' 
  },
  { 
    id: 's60', name: 'Takis Fuego', brand: 'Barcel', category: 'Snack', subCategory: 'Chips', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Hot chili pepper and lime chips.',
    urlPH: 'https://placehold.co/400x300?text=Takis', productImageFileName: 'takisFuegoSnack.jpeg' 
  },
  { 
    id: 's61', name: 'Clif Bar Chocolate Chip', brand: 'Cli', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Chocolate chips energy bar.',
    urlPH: 'https://placehold.co/400x300?text=Clif+Bar', productImageFileName: 'ClifBarSnack.jpeg' 
  },
  { 
    id: 's61a', name: 'Clif Bar Peanut Butter', brand: 'Cli', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'Chocolate chips energy bar.',
    urlPH: 'https://placehold.co/400x300?text=Clif+Bar+Peanut+Butter', productImageFileName: 'ClifBarPeanutButter.webp' 
  },
  { 
    id: 's62', name: 'Nutri-Grain', brand: 'Kellogg\'s', category: 'Snack', subCategory: 'Granola Bar', tags: ['Classic'], 
    sugarVal: 12, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Soft baked strawberry bar.',
    urlPH: 'https://placehold.co/400x300?text=Nutri-Grain', productImageFileName: 'Nutri-GrainSnackBar.jpeg' 
  },
  { 
    id: 's63', name: 'Famous Amos', brand: 'Ferrero', category: 'Snack', subCategory: 'Cookie', tags: ['Classic'], 
    sugarVal: 9, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Bite size chocolate chips cookies.',
    urlPH: 'https://placehold.co/400x300?text=Famous+Amos', productImageFileName: 'FamousAmosSnack.jpeg' 
  },
  { 
    id: 's65', name: 'Gardetto\'s', brand: 'General Mills', category: 'Snack', subCategory: 'Mix', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Original recipe snack mix.',
    urlPH: 'https://placehold.co/400x300?text=Gardettos', productImageFileName: 'GardettoSnack.jpeg' 
  },
  { 
    id: 's66', name: 'Funyuns', brand: 'Frito-Lay', category: 'Snack', subCategory: 'Chips', tags: ['Classic'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Onion flavored rings.',
    urlPH: 'https://placehold.co/400x300?text=Funyuns', productImageFileName: 'funyunsSnack.jpeg' 
  },
  { 
    id: 's67', name: 'Smartfood', brand: 'Frito-Lay', category: 'Snack', subCategory: 'Popcorn', tags: ['Healthy'], 
    sugarVal: 2, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'White cheddar popcorn.',
    urlPH: 'https://placehold.co/400x300?text=Smartfood', productImageFileName: 'SmartFoodSnack.jpeg' 
  },
  { 
    id: 's68', name: 'Fig Newtons', brand: 'Nabisco', category: 'Snack', subCategory: 'Cookie', tags: ['Classic'], 
    sugarVal: 12, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Soft and chewy fig cookies.',
    urlPH: 'https://placehold.co/400x300?text=Fig+Newtons', productImageFileName: 'FigNewtonsSnack.jpeg' 
  },

  

  // ==========================
  // NEW CANDY (s69 - s78)
  // ==========================
  { 
    id: 's69', name: 'Haribo Goldbears', brand: 'Haribo', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 14, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Gummi bears original.',
    urlPH: 'https://placehold.co/400x300?text=Goldbears', productImageFileName: 'HariboGoldBearsCandy.jpeg' 
  },
  { 
    id: 's70', name: 'Reese\'s Pieces', brand: 'Hershey', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 21, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Peanut butter candy in a shell.',
    urlPH: 'https://placehold.co/400x300?text=Reeses+Pieces', productImageFileName: 'ReesesPiecesCandy.jpeg' 
  },
  { 
    id: 's71', name: 'Mike and Ike', brand: 'Just Born', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 25, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Chewy assorted fruit flavored candy.',
    urlPH: 'https://placehold.co/400x300?text=Mike+and+Ike', productImageFileName: 'MikeandIkeCandy.jpeg' 
  },
  { 
    id: 's72', name: 'Hot Tamales', brand: 'Just Born', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 26, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Fierce cinnamon chewy candy.',
    urlPH: 'https://placehold.co/400x300?text=Hot+Tamales', productImageFileName: 'HotTamaliesCandy.jpeg' 
  },
  { 
    id: 's73', name: 'Heath Bar', brand: 'Hershey', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 5, caffeineLevel: 'Low', description: 'English toffee covered in milk chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Heath+Bar', productImageFileName: 'HealthCandyBar.jpeg' 
  },
  { 
    id: 's74', name: 'Whoppers', brand: 'Hershey', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 24, sugarLevel: 'Med', caffeineVal: 2, caffeineLevel: 'Low', description: 'The original malted milk balls.',
    urlPH: 'https://placehold.co/400x300?text=Whoppers', productImageFileName: 'whoppersCandy.jpeg' 
  },
  { 
    id: 's75', name: 'Milk Duds', brand: 'Hershey', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 20, sugarLevel: 'Med', caffeineVal: 2, caffeineLevel: 'Low', description: 'Chewy caramel in milk chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Milk+Duds', productImageFileName: 'MilkDudsCandy.jpeg' 
  },
  { 
    id: 's76', name: 'Rolo', brand: 'Hershey', category: 'Candy', subCategory: 'Chocolate', tags: ['Classic'], 
    sugarVal: 25, sugarLevel: 'High', caffeineVal: 2, caffeineLevel: 'Low', description: 'Creamy caramels in milk chocolate.',
    urlPH: 'https://placehold.co/400x300?text=Rolo', productImageFileName: 'RoloCandy.jpeg' 
  },
  { 
    id: 's77', name: 'Airheads', brand: 'Perfetti Van Melle', category: 'Candy', subCategory: 'Gummy', tags: ['Classic'], 
    sugarVal: 11, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Chewy fruit taffy.',
    urlPH: 'https://placehold.co/400x300?text=Airheads', productImageFileName: 'AirHeadsCandy.jpeg' 
  },
  { 
    id: 's78', name: 'Baby Ruth', brand: 'Ferrero', category: 'Candy', subCategory: 'Candy Bar', tags: ['Classic'], 
    sugarVal: 32, sugarLevel: 'High', caffeineVal: 5, caffeineLevel: 'Low', description: 'Chocolate, peanuts, caramel and nougat.',
    urlPH: 'https://placehold.co/400x300?text=Baby+Ruth', productImageFileName: 'BabyRuthCandyBar.jpeg' 
  },

  // ==========================
  // NEW SNACKS & PROTEIN BARS (s79 - s92)
  // ==========================
  { 
    id: 's79', name: 'BUILT Puff Bar', brand: 'Built Bar', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 6, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Protein bar with marshmallow texture.',
    urlPH: 'https://placehold.co/400x300?text=BUILT+Puff', productImageFileName: 'ccbuiltbar.webp' 
  },
  { 
    id: 's80', name: 'Quest Protein Bar', brand: 'Quest', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'High protein low carb bar.',
    urlPH: 'https://placehold.co/400x300?text=Quest+Bar', productImageFileName: 'ccquestbar.webp' 
  },
  { 
    id: 's81', name: 'Fig Bar', brand: 'Nature\'s Bakery', category: 'Snack', subCategory: 'Granola Bar', tags: ['Healthy'], 
    sugarVal: 19, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Whole wheat fig bar.',
    urlPH: 'https://placehold.co/400x300?text=Fig+Bar', productImageFileName: 'ccNaturesBakeryFigBar.webp' 
  },
  { 
    id: 's82', name: 'ZBar', brand: 'Clif Kid', category: 'Snack', subCategory: 'Granola Bar', tags: ['Healthy'], 
    sugarVal: 10, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Organic baked whole grain bar.',
    urlPH: 'https://placehold.co/400x300?text=ZBar', productImageFileName: 'ccCliffZBar.webp' 
  },
  { 
    id: 's83', name: 'RXBAR', brand: 'RXBAR', category: 'Snack', subCategory: 'Granola Bar', tags: ['Healthy'], 
    sugarVal: 13, sugarLevel: 'Med', caffeineVal: 0, caffeineLevel: 'None', description: 'Egg whites, almonds, cashews, dates.',
    urlPH: 'https://placehold.co/400x300?text=RXBAR', productImageFileName: 'RXBARSnack.jpeg' 
  },
  { 
    id: 's84', name: 'Protein Bar', brand: 'Nature Valley', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 6, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Peanut butter dark chocolate.',
    urlPH: 'https://placehold.co/400x300?text=NV+Protein', productImageFileName: 'ccNatureValueProteinBar.webp' 
  },
  { 
    id: 's85', name: 'Pure Protein', brand: 'Pure Protein', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 3, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'High protein bar.',
    urlPH: 'https://placehold.co/400x300?text=Pure+Protein', productImageFileName: 'ccPureProteinBar.webp' 
  },
  { 
    id: 's86', name: 'Chewy Granola Bar', brand: 'Quaker', category: 'Snack', subCategory: 'Granola Bar', tags: ['Classic'], 
    sugarVal: 7, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Chocolate chips granola bar.',
    urlPH: 'https://placehold.co/400x300?text=Chewy+Bar', productImageFileName: 'ccQuakerChewyBar.webp' 
  },
  { 
    id: 's87', name: 'KIND Nut Bar', brand: 'KIND', category: 'Snack', subCategory: 'Granola Bar', tags: ['Healthy'], 
    sugarVal: 5, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Whole nuts and spices.',
    urlPH: 'https://placehold.co/400x300?text=KIND+Nut', productImageFileName: 'ccKindBar.webp' 
  },
  { 
    id: 's88', name: 'Think! Bar', brand: 'think!', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy', 'Zero Sugar'], 
    sugarVal: 0, sugarLevel: 'None', caffeineVal: 0, caffeineLevel: 'None', description: 'High protein, zero sugar.',
    urlPH: 'https://placehold.co/400x300?text=Think+Bar', productImageFileName: 'ccThinkBar.webp' 
  },
  { 
    id: 's89', name: 'Pop-Tarts', brand: 'Kellogg\'s', category: 'Snack', subCategory: 'Pastry', tags: ['Classic'], 
    sugarVal: 30, sugarLevel: 'High', caffeineVal: 0, caffeineLevel: 'None', description: 'Frosted strawberry toaster pastry.',
    urlPH: 'https://placehold.co/400x300?text=Pop+Tarts', productImageFileName: 'ccPoptarts-strawberry.webp' 
  },
  { 
    id: 's90', name: 'Power Crunch Choc', brand: 'Power Crunch', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 5, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Triple chocolate wafer protein.',
    urlPH: 'https://placehold.co/400x300?text=Power+Crunch', productImageFileName: 'ccPowerCrunchTripleChocolate.webp' 
  },
  { 
    id: 's91', name: 'Power Crunch PB', brand: 'Power Crunch', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 5, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Peanut butter fudge wafer.',
    urlPH: 'https://placehold.co/400x300?text=Power+Crunch+PB', productImageFileName: 'ccPowerCrunchTriplePeanutButterFudge.webp' 
  },
  { 
    id: 's92', name: 'FULFIL Bar', brand: 'FULFIL', category: 'Snack', subCategory: 'Granola Bar', tags: ['Energy'], 
    sugarVal: 1, sugarLevel: 'Low', caffeineVal: 0, caffeineLevel: 'None', description: 'Vitamin and protein bar.',
    urlPH: 'https://placehold.co/400x300?text=FULFIL+Bar', productImageFileName: 'ccFulefilBar.webp' 
  },
];